import styled from 'styled-components';

export const WrapperReceipt = styled.div`
  .page {
    flex-wrap: wrap;
    background: white;
    position: relative;
    display: block;
    margin: 0.5cm auto;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
    justify-content: space-between;
    page-break-after: always;
    width: 12.4cm;
    color: #313131;
  }
  .next-page {
    display: block;
    width: 12.4cm;
  }
  .barcode {
    width: 72%;
    height: 96%;
  }
  .header {
    padding: 5px 10px;
    padding-bottom: 0;
    border-radius: 30px;
    background-color: #f1f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    -webkit-print-color-adjust: exact !important;

    h3 {
      font-size: 10px;
    }

    > div {
      display: flex;
      align-items: center;
    }
  }

  .header .info {
    .date {
      padding: 3px 10px;
      border-radius: 8px;
      background-color: #636363;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 1px;
      text-align: center;
      dislay: block;
      margin-bottom: 5px;
    }
    .time {
      padding: 3px 10px;
      border-radius: 8px;
      background-color: #bebebe;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 1px;
      text-align: center;
      dislay: block;
    }
    .pay-type {
      font-family: IRANYekan;
      font-size: 10px;
      font-weight: bold;
      text-align: left;
      color: #000;
      margin-top: 5px;
      margin-bottom: 0;
      text-align: center;
    }
  }

  .header .barcode {
    .route {
      font-weight: bold;
      font-size: 12px;
      margin-bottom: 0;
      text-align: center;
      margin-top: 0;
    }
  }

  main {
    margin-top: 10px;
  }

  .info-box {
    display: flex;
    margin: 0 5px;
    align-items: center;

    &.deliver {
      margin-top: 8px;
      .title {
        background-color: #bebebe;
        color: #000;
      }
    }

    &.description {
      margin-top: 8px;
      .box {
        height: 65px;
        border-style: dashed;
        margin-right: -19px;
      }
      .title {
        background-color: #bebebe;
        color: #000;
        white-space: nowrap;
        width: 69px;
        margin-right: -26px;
      }
    }

    .title {
      color: #fff;
      background-color: #636363;
      -webkit-print-color-adjust: exact !important;
      border-radius: 25px;
      text-align: center;
      transform: rotate(90deg);
      height: 100%;
      padding: 5px 10px;
      margin-right: -19px;
      width: 58px;
      font-size: 10px;
    }
    .box {
      width: 100%;
      padding: 10px;
      border: 2.5px solid #f1f0f0;
      border-radius: 11px;
      margin-right: -13px;

      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
      }

      span {
        font-size: 10px;
        font-weight: normal;
      }
      span.userInfo {
        font-weight: 700;
        margin: 0 3px;
      }

      p {
        margin-top: 5px;
        margin-bottom: 0;
        font-size: 10px;
      }
    }
  }

  .footer {
    height: 52px;
    width: 100%;
    background-image: url(/receipt-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    -webkit-print-color-adjust: exact !important;

    p {
      font-size: 12px;
      margin: 0 auto;
      font-weight: bold;
    }

    img {
      width: 120px;
      height: 50px;
    }
  }

  @media print {
    body {
      margin: 0 auto;
      /* change the margins as you want them to be. */
    }
    .page {
      page-break-after: always;
    }
  }
`;
